import { formatNumber, formatNumberAsInt } from '@blisspointmedia/bpm-types/dist/formatUtils';

// Metric formatters
// Note: these deliberately are NOT swapped for @blisspointmedia/bpm-types/dist/metricFormatUtils's
// versions of the same names. That package's formatters return a "--" zero-label whenever
// `value` is falsy (including exactly 0) or below a default `min` of 0, which would silently turn
// every 0% or negative percent-change value here into "--" instead of the real number — and
// negative percent-change is the common case for the "compare to previous period" feature these
// back (CompareMetrics.tsx). The rest of CrossChannel's real metric formatting (spend, revenue,
// cpm, cpx, roas, etc.) already goes through the package's `getMetricFormatter(currencyCode)`
// directly — see CompareMetrics/DeliverySnapshot/PerformanceSnapshot/DeliveryBreakdown/
// PerformanceBreakdown.tsx.
export const VOLUME_FORMATTER = (value: number): string =>
  value > 0 && value < 1 ? '<1' : formatNumberAsInt(value);

export const PERCENTAGE_FORMATTER = (value: number): string =>
  `${formatNumber(value * 100, 0).toLocaleString()}%`;

export const RELATIVE_FORMATTER = (value: number): string =>
  `${Math.round(value).toLocaleString()}%`;

const METRIC_TO_FORMATTER = {
  percentage: PERCENTAGE_FORMATTER,
  volume: VOLUME_FORMATTER
};

/**
 * Returns the formatter function for the provided metric.
 */
export const metricFormatter = (metric: string): ((value: number) => string) =>
  METRIC_TO_FORMATTER[metric] || METRIC_TO_FORMATTER.volume;
